/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const imageHistoryDataCollectionNameSchema = z.enum([
	'ad-asset',
	'baked-story',
	'baked-feed',
	'story',
	'feed',
	'landing-page',
	'logo',
	'generated',
	'uploaded',
	'imported',
	'candidate-files',
	'custom-font',
	'design',
	'whatsapp-profile',
])

export type ImageHistoryDataCollectionNameSchema = z.infer<typeof imageHistoryDataCollectionNameSchema>
